<template>
  <div
    class="intro-y flex flex-col lg:flex-row justify-between lg:items-end gap-0 lg:gap-2 mt-8"
  >
    <div class="flex flex-row items-end">
      <div
        class="bg-green-700 px-8 py-2 lg:text-2xl font-bold text-white text-center rounded-md"
      >
        CL
      </div>
      <h2 class="text-lg font-medium ml-4">รายละเอียด {{ cl.cl_no }}</h2>
    </div>
    <div
      class="flex flex-row justify-end mt-4 lg:mt-0 gap-2"
      v-if="!loadingPage"
    >
      <router-link
        type="button"
        :to="{ name: 'reimbursementClMyWait' }"
        class="btn box text-gray-700 flex items-center"
      >
        <ArrowLeftIcon class="w-4 h-4 mr-2 hidden md:block" /> Back
      </router-link>
      <button
        type="button"
        class="btn btn-danger disabled:opacity-50 flex items-center"
        @click.prevent="rejectCL()"
        :disabled="btnReject.disabled"
        v-show="!btnReject.hide"
      >
        <ArrowLeftIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnReject.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        ดึงเอกสารกลับ
      </button>
      <a
        href="javascript:;"
        class="btn btn-danger disabled:opacity-50 flex items-center"
        data-toggle="modal"
        data-target="#cancel-modal-preview-remark"
        :disabled="btnCancel.disabled"
        v-show="!btnCancel.hide"
      >
        <XCircleIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnCancel.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        ยกเลิกเอกสาร
      </a>
      <a
        v-if="!btnResendHide"
        v-show="!btnResend.hide"
        :disabled="btnResend.disabled"
        href="javascript:;"
        class="btn box disabled:opacity-50 flex items-center  border-2"
        data-toggle="modal"
        data-target="#resend-mail-modal-confirm"
      >
        <SendIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnResend.loading"
        />
        <LoadingIcon icon="oval" color="orange" v-else class="w-4 h-4 mr-2" />
        Send Mail
      </a>
      <BtnPrinter module="cl" :doc-id="cl.cl_id" v-if="!btnPrintHide" />
    </div>
  </div>
  <div class="grid grid-cols-12 gap-6 mt-0 lg:mt-5">
    <div class="intro-y col-span-12">
      <div class="mt-5">
        <div class="h-10 w-full text-center my-20" v-if="loadingPage">
          <LoadingIcon icon="oval" class="w-12 h-12" />
        </div>
        <div class="horizontal-form" v-else>
          <div class="mb-4" v-if="isApprove">
            <ApproveCL
              form-page="detail"
              :cl-id="cl.cl_id"
              :activity="cl.activity_list"
              :employee-id="cl.claim_id"
              :show="cl.is_approve_token_used == 0"
              :edit="cl.flag_edit == 1"
              @reload="reloadCL"
            />
          </div>
          <div class="mb-4">
            <DocumentPath
              :document-path="cl.document_path_array"
              :status-code="cl.status_code"
              :flag-edit="cl.flag_edit"
              :next-status-code="cl.next_status"
              :approve-result="cl.approve_result_array"
            />
          </div>
          <HeaderCompany
            :img-logo="cl.cl_comp.comp_logo"
            :status-name="cl.status_name"
            :participants="cl.participants"
            :document-path="cl.document_path_text_array"
          />
          <div class="mt-5">
            <TableSummaryCost :items="cl.itemSummary" />
          </div>
          <div class="box intro-y mt-5 p-5">
            <HeaderOwner
              :reqName="cl.req_name"
              :companyName="cl.cl_comp.comp_name_th"
              :buNo="cl.bu_no"
              :buName="cl.bu_name"
              :telephone="cl.telephone"
            />
          </div>
          <!-- header 2 -->

          <div class="grid grid-cols-1 lg:grid-cols-3 mt-5 lg:gap-4">
            <!-- ข้อมูลค่าใช้จ่าย -->
            <div class="intro-y box p-5 col-span-2">
              <div class="font-bold text-lg">ข้อมูลค่าใช้จ่าย</div>
              <div class="mt-4">
                <label class="form-label font-bold">รายละเอียด:</label>
                <div
                  class="overflow-x-auto"
                  v-html="
                    cl.req_detail
                      ? cl.req_detail.replaceAll('\n', '<br />')
                      : ''
                  "
                ></div>
              </div>
              <div class="mt-4">
                <label for="" class="form-label font-bold">เอกสารจาก CA:</label>
                <div>
                  <a
                    :href="cl.ca_info.ca_link"
                    class="text-blue-400"
                    target="_blank"
                    >{{ cl.ca_info.doc_no_full }} -
                    {{ cl.ca_info.doc_title }}</a
                  >
                </div>
              </div>
              <div class="mt-4">
                <label for="" class="form-label font-bold"
                  >เอกสารจาก Memo:</label
                >
                <div>
                  <a
                    :href="cl.ememo_link"
                    class="text-blue-400"
                    target="_blank"
                    >{{ cl.ememo_title }}</a
                  >
                </div>
              </div>
              <div class="mt-4 col-span-1">
                <label class="form-label font-bold">ไฟล์แนบ:</label>
                <AttachFilePreview :data="cl.file_attach_array" grid />
              </div>
            </div>
            <!-- ข้อมูลด้านบัญชี -->
            <div class="intro-y box p-5 mt-5 lg:mt-0">
              <div class="font-bold text-lg mb-4">ข้อมูลด้านบัญชี</div>
              <GLDate
                url="reimbursement/cl/updateClGldate"
                :id="cl.cl_id"
                :glDate="cl.glDate"
                :isPermissionVat="cl.is_permission_vat"
                :isApprove="isApprove"
                :isClaim="isClaim"
                classLabel="flex flex-row justify-between"
              />
              <div class="flex flex-row justify-between">
                <label class="form-label font-bold">ชำระโดย:</label>
                <div>{{ cl.petty_cash.label }}</div>
              </div>
              <div class="flex flex-row justify-between">
                <label class="form-label font-bold">จ่ายให้:</label>
                <div>
                  {{
                    cl.payee_no && cl.payee_no != ''
                      ? `(${cl.payee_no}) - ${cl.payee_name}`
                      : 'ไม่ระบุ'
                  }}
                </div>
              </div>
            </div>
          </div>

          <!-- items -->

          <div class="mt-5 gap-4">
            <div class="intro-y box p-5 space-y-4">
              <div class="text-lg font-bold">รายการเบิก</div>
              <div
                class="border rounded p-5"
                v-for="(item, index) in cl.items"
                :key="item.cl_item_id"
              >
                <div class="font-bold text-xl mb-4">
                  ลำดับที่ {{ index + 1 }}.
                </div>
                <div class="grid grid-cols-1 lg:grid-cols-3  lg:gap-4">
                  <!-- col-1 -->
                  <div
                    v-if="!(cl.is_permission_vat != 0 && isApprove && !isClaim)"
                  >
                    <div class="text-lg font-bold">รายละเอียดค่าใช้จ่าย</div>
                    <div class="flex justify-between">
                      <div class="font-bold">เลขที่ใบเสร็จ/ใบกำกับภาษี:</div>
                      <div>{{ item.receipt_no }}</div>
                    </div>
                    <div class="flex justify-between">
                      <div class="font-bold">
                        วันที่เลขที่ใบเสร็จ/ใบกำกับภาษี:
                      </div>
                      <div>{{ item.receipt_date }}</div>
                    </div>
                    <div class="flex justify-between">
                      <div class="font-bold">Vendor:</div>
                      <div>
                        {{
                          item.vendor_no && item.vendor_no != ''
                            ? `(${item.vendor_no}) - ${item.vendor_name}`
                            : 'ไม่ระบุ'
                        }}
                      </div>
                    </div>
                    <div>
                      <div class="font-bold">รายละเอียดค่าใช้จ่าย:</div>
                      <div
                        class="overflow-x-auto"
                        v-html="
                          item.detail
                            ? item.detail.replaceAll('\n', '<br>')
                            : ''
                        "
                      ></div>
                    </div>
                    <div class="flex justify-between">
                      <div class="font-bold">จำนวนเงิน (บาท):</div>
                      <div>{{ numberFormat(item.amount) }}</div>
                    </div>
                    <div class="flex justify-between">
                      <div class="font-bold">
                        ภาษีมูลค่าเพิ่ม
                        {{ item.vat_rate > 0 ? `(${item.vat_rate}%)` : '' }}:
                      </div>
                      <div>{{ numberFormat(item.vat) }}</div>
                    </div>
                    <div class="flex justify-between">
                      <div class="font-bold">
                        ภาษีหัก ณ ที่จ่าย
                        {{
                          item.wh_tax_rate > 0 ? `(${item.wh_tax_rate}%)` : ''
                        }}:
                      </div>
                      <div>{{ numberFormat(item.wh_tax) }}</div>
                    </div>
                    <div class="flex justify-between">
                      <div class="font-bold">ค่าใช้จ่ายจริง:</div>
                      <div>{{ numberFormat(item.actual_cost) }}</div>
                    </div>
                    <!-- <div class="text-theme-6 font-bold">
                      {{ item.is_itself_tax === 1 ? '* บริษัทรับภาระเอง' : '' }}
                    </div> -->
                  </div>
                  <div class="space-y-4" v-else>
                    <div>
                      <label for="" class="form-label "
                        >เลขที่ใบเสร็จ/ใบกำกับภาษี
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="item.receipt_no"
                        maxlength="50"
                        placeholder="(ไม่เกิน 50 ตัวอักษร)"
                      />
                    </div>
                    <!-- <div class="">
                      <label for="" class="form-label "
                        >วันที่เลขที่ใบเสร็จ/ใบกำกับภาษี
                      </label>
                      <input
                        type="date"
                        class="form-control"
                        v-model="item.receipt_date"
                      />
                    </div> -->
                    <div class="p-fluid p-grid">
                      <div class="p-field p-field-sm">
                        <label for="">วันที่เลขที่ใบเสร็จ/ใบกำกับภาษี </label>
                        <Calendar
                          class="mt-2"
                          inputStyle="padding:0.5rem 0.75rem;"
                          v-model="item.receipt_date"
                          dateFormat="yy-mm-dd"
                          placeholder="2022-01-01"
                        />
                      </div>
                    </div>
                    <div class="">
                      <label for="" class="form-label font-bold"
                        >Vendor:
                      </label>
                      <div>
                        {{
                          item.vendor_no && item.vendor_no != ''
                            ? `(${item.vendor_no}) - ${item.vendor_name}`
                            : 'ไม่ระบุ'
                        }}
                      </div>
                    </div>
                    <div class="">
                      <label for="" class="form-label font-bold"
                        >รายละเอียดค่าใช้จ่าย:
                      </label>
                      <div
                        class="overflow-x-auto"
                        v-html="
                          item.detail
                            ? item.detail.replaceAll('\n', '<br>')
                            : ''
                        "
                      ></div>
                    </div>
                    <div class="">
                      <label for="" class="form-label font-bold"
                        >จำนวนเงิน(บาท)</label
                      >
                      <div>{{ numberFormat(item.amount) }}</div>
                    </div>
                    <div class="">
                      <label for="" class="form-label ">ภาษีมูลค่าเพิ่ม</label>
                      <div class="grid grid-cols-4 space-x-2">
                        <input
                          type="number"
                          class="form-control col-span-2"
                          min="0"
                          v-model.number="item.vat"
                          @keyup="calVat(index)"
                          @change="calVat(index)"
                          :disabled="!item.taxVatProcess"
                        />
                        <input
                          type="number"
                          class="form-control"
                          v-model.number="item.vat_rate"
                          min="0"
                          max="100"
                          @keyup="calVatProcess(index)"
                          @change="calVatProcess(index)"
                        />
                        <button
                          class="btn"
                          :class="[
                            item.taxVatProcess ? 'btn-primary' : 'btn-secondary'
                          ]"
                          @click="
                            ;[
                              (item.taxVatProcess = !item.taxVatProcess),
                              calVatProcess(index)
                            ]
                          "
                        >
                          คำนวณ
                        </button>
                      </div>
                    </div>
                    <div class="">
                      <label for="" class="form-label "
                        >ภาษีหัก ณ ที่จ่าย</label
                      >
                      <div class="grid grid-cols-4 space-x-2">
                        <input
                          type="number"
                          class="form-control col-span-2"
                          min="0"
                          v-model.number="item.wh_tax"
                          @keyup="calTax(index)"
                          @change="calTax(index)"
                          :disabled="!item.taxWhProcess"
                        />
                        <input
                          type="number"
                          class="form-control"
                          v-model.number="item.wh_tax_rate"
                          min="0"
                          max="100"
                          @keyup="calTaxProcess(index)"
                          @change="calTaxProcess(index)"
                        />
                        <button
                          class="btn"
                          :class="[
                            item.taxWhProcess ? 'btn-primary' : 'btn-secondary'
                          ]"
                          @click="
                            ;[
                              (item.taxWhProcess = !item.taxWhProcess),
                              calTaxProcess(index)
                            ]
                          "
                        >
                          คำนวณ
                        </button>
                      </div>
                    </div>
                    <!-- <div class="form-check mt-2">
                      <input
                        id="isItselfTax"
                        type="checkbox"
                        class="form-check-input"
                        v-model="item.is_itself_tax"
                      />
                      <label
                        for="isItselfTax"
                        class="form-check-label text-theme-6"
                        >บริษัทรับภาระเอง</label
                      >
                    </div> -->
                    <div class="">
                      <label for="" class="form-label ">ค่าใช้จ่ายจริง</label>
                      <input
                        type="number"
                        class="form-control"
                        v-model.number="item.actual_cost"
                      />
                    </div>
                    <div>
                      <button
                        class="btn btn-warning"
                        @click="updateItemActualCost(index)"
                      >
                        อัพเดท
                      </button>
                    </div>
                  </div>
                  <!-- col-2 -->
                  <div class="col-span-2 mt-4 lg:mt-0">
                    <div>
                      <div class="text-lg font-bold">รายละเอียดงบประมาณ</div>
                      <div class="flex justify-between">
                        <div class="font-bold">
                          ปีงบประมาณ:
                        </div>
                        <div>{{ item.budget_year }}</div>
                      </div>
                      <div class="flex justify-between">
                        <div class="font-bold">
                          ชนิดงบประมาณ:
                        </div>
                        <div>
                          {{
                            item.budget_subledger
                              ? 'งบประมาณโครงการ'
                              : 'งบประมาณหน่วยงาน'
                          }}
                        </div>
                      </div>
                      <div class="flex justify-between">
                        <div class="font-bold">
                          ใช้งบประมาณของหน่วยงาน:
                        </div>
                        <div>
                          {{ item.budget_bu_name }}
                        </div>
                      </div>
                      <div class="flex justify-between">
                        <div class="font-bold">
                          รหัส BU:
                        </div>
                        <div>
                          {{ item.budget_bu_code }}
                        </div>
                      </div>
                      <div class="flex justify-between">
                        <div class="font-bold">Account Code:</div>
                        <div>
                          {{ item.budget_code }}
                        </div>
                      </div>
                      <div class="flex justify-between">
                        <div class="font-bold">Subsidiary:</div>
                        <div>
                          {{ item.budget_subsidiary }}
                        </div>
                      </div>
                      <div class="flex justify-between">
                        <div class="font-bold">Account Name:</div>
                        <div>
                          {{ item.budget_name }}
                        </div>
                      </div>
                      <div class="flex justify-between">
                        <div class="font-bold">
                          Subledger:
                        </div>
                        <div>
                          {{ item.budget_subledger }}
                        </div>
                      </div>
                      <div class="flex justify-between">
                        <div class="font-bold">
                          Subledger Name:
                        </div>
                        <div>
                          {{ item.budget_subledger_name }}
                        </div>
                      </div>
                    </div>
                    <!-- col-3 -->
                    <div class="mt-4">
                      <div class="text-lg font-bold">รายละเอียดภาษี</div>
                      <div
                        v-if="
                          !(cl.is_permission_vat != 0 && isApprove && !isClaim)
                        "
                      >
                        <BcVatLabel
                          v-if="isBc"
                          :key="index"
                          :bcVatProd="item.bc_vat_prod"
                          :bcWhtBus="item.bc_wht_bus"
                          :bcWhtProd="item.bc_wht_prod"
                          :bcElim="item.bc_elim"
                        />
                        <!-- <div class="flex justify-between">
                          <div class="font-bold">Tax Rate:</div>
                          <div>
                            {{ getTaxRate(item.tax_rate) }}
                          </div>
                        </div>
                        <div class="flex justify-between">
                          <div class="font-bold">GL Offset:</div>
                          <div>
                            {{ item.gl_offset ? item.gl_offset : 'ไม่ระบุ' }}
                          </div>
                        </div>
                        <div class="flex justify-between">
                          <div class="font-bold">Cat Code:</div>
                          <div>{{ getCatCode(item.cat_code) }}</div>
                        </div>
                        <div class="flex justify-between">
                          <div class="font-bold">
                            Analysis Code 1:
                          </div>
                          <div>
                            {{
                              getAnalysisCodeText(
                                item.analysis_code_array.analysis_code_1
                              )
                            }}
                          </div>
                        </div>
                        <div class="flex justify-between">
                          <div class="font-bold">
                            Analysis Code 2:
                          </div>
                          <div>
                            {{
                              getAnalysisCodeText(
                                item.analysis_code_array.analysis_code_2
                              )
                            }}
                          </div>
                        </div>
                        <div class="flex justify-between">
                          <div class="font-bold">
                            Analysis Code 9:
                          </div>
                          <div>
                            {{
                              getAnalysisCodeText(
                                item.analysis_code_array.analysis_code_9
                              )
                            }}
                          </div>
                        </div>
                        <div class="flex justify-between">
                          <div class="font-bold">
                            Analysis Code 10 (Tax Rate):
                          </div>
                          <div>
                            {{
                              getAnalysisCodeText(
                                item.analysis_code_array.analysis_code_10
                              )
                            }}
                          </div>
                        </div>
                        <div class="flex justify-between">
                          <div class="font-bold">
                            Asset Code:
                          </div>
                          <div>
                            {{ item.asset_code || 'ไม่ระบุ' }}
                          </div>
                        </div>
                        <div class="flex justify-between">
                          <div class="font-bold">
                            Asset Indicator:
                          </div>
                          <div>
                            {{ item.asset_indicator || '-' }}
                          </div>
                        </div> -->
                      </div>
                      <div v-else class="space-y-4">
                        <!-- <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div class="space-y-4">
                            <div class="">
                              <label for="" class="form-label ">Tax Rate</label>
                              <select
                                name=""
                                class="form-control form-select"
                                v-model="item.tax_rate"
                              >
                                <option :value="null">-- select --</option>
                                <option
                                  :value="tax.tax_code"
                                  v-for="tax in taxRateOptions"
                                  :key="tax.tax_code"
                                  >{{ tax.tax_code }} -
                                  {{ tax.tax_name }}</option
                                >
                              </select>
                            </div>
                            <div class="">
                              <label for="" class="form-label "
                                >GL Offset</label
                              >
                              <input
                                type="text"
                                class="form-control"
                                v-model="item.gl_offset"
                                maxlength="4"
                              />
                            </div>
                            <div class="">
                              <label for="" class="form-label ">Cat Code</label>
                              <select
                                name=""
                                class="form-control form-select"
                                v-model="item.cat_code"
                              >
                                <option :value="null">-- select --</option>
                                <option
                                  :value="cat.cat_code"
                                  v-for="cat in catCodeOptions"
                                  :key="cat.cat_code"
                                  >{{ cat.cat_code }} -
                                  {{ cat.cat_name }}</option
                                >
                              </select>
                              <div class="text-theme-6 text-sm">
                                * ทั้งนี้ code : 2400 ไม่ต้องระบุ
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <!-- <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                          <div>
                            <label for="" class="form-label "
                              >Analysis Code 1</label
                            >
                            <select
                              name=""
                              class="form-control form-select"
                              v-model="item.analysis_code_array.analysis_code_1"
                            >
                              <option value="">-- select --</option>
                              <option
                                :value="analysisCode.code"
                                v-for="analysisCode in analysisCodeOption1"
                                :key="analysisCode.code"
                                >{{ analysisCode.code }} -
                                {{ analysisCode.name }}</option
                              >
                            </select>
                          </div>
                          <div>
                            <label for="" class="form-label "
                              >Analysis Code 2</label
                            >
                            <select
                              name=""
                              class="form-control form-select"
                              v-model="item.analysis_code_array.analysis_code_2"
                            >
                              <option value="">-- select --</option>
                              <option
                                :value="analysisCode.code"
                                v-for="analysisCode in analysisCodeOption2"
                                :key="analysisCode.code"
                                >{{ analysisCode.code }} -
                                {{ analysisCode.name }}</option
                              >
                            </select>
                          </div>
                          <div>
                            <label for="" class="form-label "
                              >Analysis Code 9</label
                            >
                            <select
                              name=""
                              class="form-control form-select"
                              v-model="item.analysis_code_array.analysis_code_9"
                            >
                              <option value="">-- select --</option>
                              <option
                                :value="analysisCode.code"
                                v-for="analysisCode in analysisCodeOption9"
                                :key="analysisCode.code"
                                >{{ analysisCode.code }} -
                                {{ analysisCode.name }}</option
                              >
                            </select>
                          </div>
                          <div>
                            <label for="" class="form-label "
                              >Analysis Code 10 (Tax Rate)</label
                            >
                            <select
                              name=""
                              class="form-control form-select"
                              :class="{
                                'border-theme-6':
                                  item.vat > 0 &&
                                  item.analysis_code_array.analysis_code_10 ==
                                    'Z'
                              }"
                              v-model="
                                item.analysis_code_array.analysis_code_10
                              "
                            >
                              <option value="">-- select --</option>
                              <option
                                :value="analysisCode.code"
                                v-for="analysisCode in analysisCodeOption10"
                                :key="analysisCode.code"
                                >{{ analysisCode.code }} -
                                {{ analysisCode.name }}</option
                              >
                            </select>
                          </div>
                          <div>
                            <label for="" class="form-label ">Asset Code</label>
                            <input
                              type="text"
                              class="form-control"
                              v-model="item.asset_code"
                            />
                          </div>
                          <div>
                            <label for="" class="form-label "
                              >Asset Indicator</label
                            >
                            <select
                              name=""
                              class="form-control form-select"
                              v-model="item.asset_indicator"
                            >
                              <option value="">-- select --</option>
                              <option
                                :value="tax.tax_code"
                                v-for="tax in taxRateOptions"
                                :key="tax.tax_code"
                                >{{ tax.tax_code }} - {{ tax.tax_name }}</option
                              >
                            </select>
                          </div>
                        </div> -->
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <BcVat
                            :key="index"
                            :bcVatProd="item.bc_vat_prod"
                            :bcWhtBus="item.bc_wht_bus"
                            :bcWhtProd="item.bc_wht_prod"
                            :bcElim="item.bc_elim"
                            v-model:vatProd="item.bc_vat_prod"
                            v-model:whtBus="item.bc_wht_bus"
                            v-model:whtProd="item.bc_wht_prod"
                            v-model:elim="item.bc_elim"
                            :invalidVat="
                              item.vat > 0 && item.bc_vat_prod == null
                            "
                            :invalidWhtBus="
                              item.wh_tax > 0 && item.bc_wht_bus == null
                            "
                            :invalidWhtProd="
                              item.wh_tax > 0 && item.bc_wht_prod == null
                            "
                          />
                        </div>
                        <div class="mt-5">
                          <button
                            class="btn btn-warning"
                            @click="updateItemVat(index)"
                          >
                            อัพเดท
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- table summary -->
          <div class="mt-5">
            <TableHistory :items="cl.historyArray" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <ModalResendEmail module="reimbursement" :docId="cl.cl_id" docType="CL" />
  <ModalCancelRemark
    module="reimbursement"
    doc-type="cl"
    :doc-id="cl.cl_id"
    redirect-complete="reimbursementClMyWait"
  />
</template>

<script>
import {
  defineComponent,
  computed,
  reactive,
  onMounted,
  ref,
  onUnmounted
} from 'vue'
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { api } from '../../../utils/api'
import alert from '../../../helpers/alert'
import helpers from '../../../helpers'
import ApproveCL from '@/components/approve-cl/Main.vue'
import DocumentPath from '@/components/document-path/Main.vue'
import TableSummaryCost from '@/components/TableSummaryCost.vue'
import TableHistory from '@/components/TableHistory.vue'
import AttachFilePreview from '@/components/attach-file/Preview.vue'
import BtnPrinter from '@/components/BtnPrinter.vue'
import ModalResendEmail from '@/components/ModalResendEmail.vue'
import HeaderCompany from '@/components/HeaderCompany.vue'
import HeaderOwner from '@/components/HeaderOwner.vue'
import GLDate from '@/components/GLDate.vue'
import ModalCancelRemark from '@/components/ModalCancelRemark.vue'
import BcVatLabel from '../../../components/BcVatLabel.vue'
import BcVat from '../../../components/BcVat.vue'

export default defineComponent({
  components: {
    ApproveCL,
    DocumentPath,
    TableSummaryCost,
    AttachFilePreview,
    BtnPrinter,
    TableHistory,
    ModalResendEmail,
    HeaderCompany,
    HeaderOwner,
    GLDate,
    ModalCancelRemark,
    BcVatLabel,
    BcVat
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const loadingPage = computed(() => store.state.global.loadingPage)
    const btnCancel = computed(() => store.state.cl.btnCancel)
    const btnReject = computed(() => store.state.cl.btnReject)
    const btnResend = computed(() => store.state.global.btnResend)
    const btnResendHide = ref(false)
    const btnPrintHide = ref(false)

    // const companyOptions = computed(() => store.state.global.company)
    // const cashOptions = computed(() => store.state.global.cash)
    const taxRateOptions = computed(() => store.state.global.taxRate)
    const catCodeOptions = computed(() => store.state.global.catCode)
    const userInfo = computed(() => store.state.auth.info)
    const isBc = computed(() => process.env.VUE_APP_ACCOUNT_MODULE == 'BC365')

    const isClaim = computed(() => store.state.cl.isClaim)

    // const analysisCodeOption = computed(() => store.state.global.analysisCode)
    const analysisCodeOption1 = computed(() => store.state.global.analysisCode1)
    const analysisCodeOption2 = computed(() => store.state.global.analysisCode2)
    const analysisCodeOption9 = computed(() => store.state.global.analysisCode9)
    const analysisCodeOption10 = computed(
      () => store.state.global.analysisCode10
    )

    const { numberFormat, numberFormat2, dateFormat } = helpers

    const isOwner = ref(false)
    const isApprove = ref(false)

    const cl = reactive({
      owner_name: '',
      cl_no: '',
      status_code: null,
      next_status: null,
      cl_id: null,
      claim_id: '',
      glDate: '',
      activity_list: [],
      document_path_text_array: [],
      document_path_array: [],
      approve_result_array: [],
      cl_comp: {
        comp_name_th: '',
        comp_logo: ''
      },
      telephone: '',
      bu_no: '',
      bu_name: '',
      petty_cash: {},
      req_name: '',
      req_detail: '',
      ememo_id: '',
      ememo_title: '',
      ememo_link: '',
      flag_edit: 0,
      file_attach_array: [],
      items: [],
      itemSummary: [],
      historyArray: [],
      is_approve_token_used: 0,
      status_name: '',
      participants: '',
      payee_no: '',
      payee_name: 'ไม่ระบุ',
      is_permission_vat: false,
      ca_info: {
        doc_no_full: '',
        title: '',
        ca_link: null
      }
    })

    const calVat = i => {
      cl.items[i].actual_cost = numberFormat2(
        cl.items[i].amount + cl.items[i].vat - cl.items[i].wh_tax
      )
    }

    const calTax = i => {
      cl.items[i].actual_cost = numberFormat2(
        cl.items[i].amount + cl.items[i].vat - cl.items[i].wh_tax
      )
    }

    const calVatProcess = i => {
      if (cl.items[i].taxVatProcess) {
        if (cl.items[i].vat_rate > 0 && cl.items[i].vat_rate <= 100) {
          cl.items[i].vat = (cl.items[i].amount * cl.items[i].vat_rate) / 100
        } else {
          cl.items[i].vat = 0
        }
      } else {
        cl.items[i].vat = 0
      }
      calVat(i)
    }

    const calTaxProcess = i => {
      if (cl.items[i].taxWhProcess) {
        if (cl.items[i].wh_tax_rate > 0 && cl.items[i].wh_tax_rate <= 100) {
          cl.items[i].wh_tax =
            (cl.items[i].amount * cl.items[i].wh_tax_rate) / 100
        } else {
          cl.items[i].wh_tax = 0
        }
      } else {
        cl.items[i].wh_tax = 0
      }
      calTax(i)
    }

    const calActualCost = i => {
      cl.items[i].actual_cost =
        cl.items[i].amount + cl.items[i].vat - cl.items[i].wh_tax
    }

    const updateItemActualCost = async i => {
      const data = {
        receipt_no: cl.items[i].receipt_no,
        receipt_date: dateFormat(cl.items[i].receipt_date),
        vat_rate: cl.items[i].vat_rate,
        vat: cl.items[i].vat,
        wh_tax_rate: cl.items[i].wh_tax_rate,
        wh_tax: cl.items[i].wh_tax,
        actual_cost: cl.items[i].actual_cost
      }
      await api
        .put(
          `${process.env.VUE_APP_API_URL}/reimbursement/cl/updateItemExpenses/${cl.items[i].cl_item_id}`,
          data
        )
        .then(res => {
          if (res.code == 200) {
            alert.success()
          } else {
            alert.error(res.message)
          }
        })
        .catch(e => {
          alert.error(e.message)
        })
    }

    const loadCL = async () => {
      if (route.params.id) {
        await api
          .get(
            `${process.env.VUE_APP_API_URL}/reimbursement/cl/getByClId/${route.params.id}`
          )
          .then(res => {
            // cl.cl_id = route.params.id
            cl.cl_id = res.data.cl_id
            cl.activity_list = res.data.allow_list_array
              ? res.data.allow_list_array.activity_list
              : []
            cl.owner_name = res.data.owner_name
            cl.cl_no = res.data.doc_no_full
            cl.claim_id = res.data.claim_id
            cl.is_approve_token_used = res.data.is_approve_token_used
            cl.status_code = res.data.status_code
            cl.next_status = res.data.next_status
            cl.document_path_text_array = res.data.document_path_text_array
            cl.document_path_array = res.data.document_path_array
            cl.approve_result_array = res.data.approve_result_array
            cl.req_name = res.data.req_name
            cl.telephone = res.data.telephone
            cl.bu_no = res.data.bu_no
            cl.bu_name = res.data.bu_name
            cl.petty_cash = res.data.petty_cash
            cl.req_detail = res.data.req_detail
            // cl.items = res.data.items
            cl.flag_edit = res.data.flag_edit
            cl.status_name = res.data.status_name
            cl.participants = res.data.participants
            cl.is_permission_vat = res.data.is_permission_vat == 1
            cl.itemSummary = res.data.itemSummary
            cl.payee_no = res.data.payee_no
            cl.payee_name = res.data.payee_name
            cl.glDate = res.data.gl_date !== null ? res.data.gl_date : ''
            cl.historyArray = res.data.history_array

            cl.ememo_id = res.data.ememo_id
            cl.ememo_title = res.data.ememo_title
            cl.ememo_link = `${process.env.VUE_APP_BASE_URL}/memo/myActivities/form/${res.data.ememo_id}/detail`
            cl.file_attach_array = res.data.file_attach_array
            cl.ca_info.doc_no_full = res.data.ca_info.doc_no_full
            cl.ca_info.doc_title = res.data.ca_info.doc_title
            cl.ca_info.ca_link = `${process.env.VUE_APP_BASE_URL}/reimbursement/ca/form/${res.data.ca_id}/detail`

            cl.cl_comp = store.getters['global/companyFind'](res.data.cl_comp)
            cl.petty_cash = store.getters['global/cashFind'](
              res.data.petty_cash
            )

            if (
              res.data.status_code == 'CL_COMPLETE' &&
              store.getters['auth/checkAccountHead'](res.data.docComp)
            ) {
              store.commit('cl/setBtn', { type: 'btnCancel', value: 'hide' })
            }

            if (
              store.getters['auth/checkDocOwner'](res.data.owner_id) &&
              res.data.status_code != 'CL_DRAFT' &&
              res.data.status_code != 'CL_COMPLETE'
            ) {
              store.commit('global/setBtnHide', {
                type: 'btnResend',
                status: false
              })
            }

            cl.items = res.data.items.map(item => {
              item.taxVatProcess = item.vat > 0
              item.taxWhProcess = item.wh_tax > 0

              return item
            })

            if (res.data.status_code == 'CL_CANCELLED') {
              btnResendHide.value = true
              btnPrintHide.value = true
            }

            if (userInfo.value.employeeId == res.data.owner_id) {
              isOwner.value = true
              if (
                res.data.is_editing != 1 &&
                res.data.status_code == 'CMD_REVIEW'
              ) {
                store.commit('cl/setBtn', { type: 'btnReject', value: 'hide' })
              } else {
                if (
                  store.state.cl.btnReject.hide &&
                  res.data.status_code == 'CMD_REVIEW'
                ) {
                  store.commit('cl/setBtn', {
                    type: 'btnReject',
                    value: 'hide'
                  })
                }
              }
            }

            isApprove.value = false
            if (res.data.allow_list_array) {
              res.data.allow_list_array.activity_list.map(item => {
                if (item.employee_id == userInfo.value.employeeId) {
                  isApprove.value = true
                }
              })
            }

            store.commit(
              'cl/setIsClaim',
              res.data.claim_id === null && isApprove.value
            )
            store.commit('cl/setIsApprove', false)

            store.commit('global/setOverBudget', {
              message:
                res.data.is_over_budget == 1
                  ? 'เกินงบประมาณ'
                  : 'อยู่ในงบประมาณ',
              isOver: res.data.is_over_budget == 1,
              show: true
            })
          })
      }
    }

    const reloadCL = () => {
      loadCL()
    }

    const rejectCL = async () => {
      store.commit('cl/setBtnActive', { type: 'btnReject' })
      await api
        .put(
          `${process.env.VUE_APP_API_URL}/reimbursement/cl/editBeforeApprove/${route.params.id}`
        )
        .then(res => {
          if (res.code == 200) {
            store.commit('cl/setBtnActive', { type: 'btnReject' })
            router.push({
              name: 'reimbursementClFormEdit',
              params: { id: route.params.id }
            })
          } else {
            alert.error(res.message)
          }
        })
        .catch(e => {
          alert.error(e.message)
        })
    }

    const getTaxRate = taxRate => {
      if (taxRate) {
        const rate = taxRateOptions.value.find(
          item => item.tax_code === taxRate
        )
        if (rate) {
          return `${rate.tax_code} - ${rate.tax_name}`
        } else {
          return `ไม่พบรหัสที่: ${taxRate}`
        }
      } else {
        return 'ไม่ระบุ'
      }
    }

    const getCatCode = catCode => {
      if (catCode !== null) {
        const code = catCodeOptions.value.find(
          item => item.cat_code === catCode
        )
        if (code) {
          return `${code.cat_code} - ${code.cat_name}`
        } else {
          return 'ข้อมูลไม่ตรงกัน'
        }
      } else {
        return 'ไม่ระบุ'
      }
    }

    const updateGlDate = async () => {
      await api
        .put(
          `${process.env.VUE_APP_API_URL}/reimbursement/cl/updateClGldate/${route.params.id}`,
          {
            gl_date: dateFormat(cl.glDate)
          }
        )
        .then(res => {
          if (res.code == 200) {
            alert.success()
          } else {
            alert.error()
          }
        })
        .catch(e => {
          alert.error(e.message)
        })
    }

    // const updateItemVat = async index => {
    //   if (
    //     cl.items[index].vat > 0 &&
    //     cl.items[index].analysis_code_array.analysis_code_10 == 'Z'
    //   ) {
    //     alert.error('กรุณาเลือก Analysis Code 10')
    //     return
    //   }
    //   const updateVat = {
    //     cat_code: cl.items[index].cat_code,
    //     tax_rate: cl.items[index].tax_rate,
    //     gl_offset: cl.items[index].gl_offset,
    //     analysis_code_1: cl.items[index].analysis_code_array.analysis_code_1,
    //     analysis_code_2: cl.items[index].analysis_code_array.analysis_code_2,
    //     analysis_code_9: cl.items[index].analysis_code_array.analysis_code_9,
    //     analysis_code_10: cl.items[index].analysis_code_array.analysis_code_10,
    //     asset_code: cl.items[index].asset_code,
    //     asset_indicator: cl.items[index].asset_indicator
    //   }
    //   await api
    //     .put(
    //       `${process.env.VUE_APP_API_URL}/reimbursement/cl/updateItemVat/${cl.items[index].cl_item_id}`,
    //       updateVat
    //     )
    //     .then(res => {
    //       if (res.code == 200) {
    //         alert.success()
    //       } else {
    //         alert.error()
    //       }
    //     })
    //     .catch(e => {
    //       alert.error(e.message)
    //     })
    // }
    const updateItemVat = async index => {
      // if (pv.items[index].vat > 0 && pv.items[index].tax_rate == null) {
      //   alert.error('กรุณาเลือก Tax Rate')
      //   return
      // }
      if (cl.items[index].vat > 0 && cl.items[index].bc_vat_prod == null) {
        alert.error('กรุณาเลือก Vat Prod')
        return
      }
      if (
        cl.items[index].wh_tax > 0 &&
        (cl.items[index].bc_wht_bus == null ||
          cl.items[index].bc_wht_prod == null)
      ) {
        alert.error('กรุณาเลือก WHT Bus และ WHT Prod')
        return
      }
      const updateVat = {
        bc_vat_prod: cl.items[index].bc_vat_prod,
        bc_wht_bus: cl.items[index].bc_wht_bus,
        bc_wht_prod: cl.items[index].bc_wht_prod,
        bc_elim: cl.items[index].bc_elim
      }
      await api
        .put(
          `${process.env.VUE_APP_API_URL}/reimbursement/cl/updateItemVat/${cl.items[index].cl_item_id}`,
          updateVat
        )
        .then(res => {
          if (res.code == 200) {
            alert.success()
          } else {
            alert.error()
          }
        })
        .catch(e => {
          alert.error(e.message)
        })
    }

    const getAnalysisCodeText = code => {
      return store.getters['global/getAnalysisCodeText'](code)
    }

    onUnmounted(() => {
      console.log('unmounted page cl detail')
      store.commit('cl/initBtn')
      isOwner.value = false
      isApprove.value = false
    })

    onMounted(async () => {
      console.log('mounted page cl detail')
      await store.dispatch('global/loadCompany')
      await store.dispatch('global/loadCash')
      // await store.dispatch('global/loadTaxRate')
      // await store.dispatch('global/loadCatCode')
      // await store.dispatch('global/loadOptionAnalysisCode')
      await store.dispatch('global/loadBc')
      await loadCL()
      store.commit('global/setLoadingPage', false)
    })

    return {
      btnCancel,
      btnReject,
      rejectCL,
      cl,
      reloadCL,
      loadingPage,
      getTaxRate,
      getCatCode,
      numberFormat,
      dateFormat,
      isOwner,
      isApprove,
      taxRateOptions,
      catCodeOptions,
      updateItemVat,
      updateGlDate,
      isClaim,
      calVat,
      calTax,
      calVatProcess,
      calTaxProcess,
      calActualCost,
      updateItemActualCost,
      btnResend,
      btnResendHide,
      btnPrintHide,
      // analysisCodeOption,
      analysisCodeOption1,
      analysisCodeOption2,
      analysisCodeOption9,
      analysisCodeOption10,
      getAnalysisCodeText,
      isBc
    }
  }
})
</script>
